import { Fragment, useEffect, useState } from 'react';

import classes from './PassKeyExpiredPopup.module.scss';
import passkeyImg from '../../../../assets/img/passkey.svg';
import arrowLeftWhite from '../../../../assets/icons/arrow-left-white.svg';
import arrowRightWhite from '../../../../assets/icons/arrow-right-white.svg';

declare function Translate(key: string): string;
declare var _curLang: any;

const PassKeyExpiredPopup = (props) => {

    useEffect(() => {
        document.getElementById('btnPkExpired')?.focus();
    },[]);

    const handleContinueClick = () => {  
        props.Continue();
      };
  
    const handleContinuePress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            handleContinueClick();
        }        
    };

    const handleEscape = (event) => {       
        if (event.keyCode === 27){
            props.close();
        }
    };

    const cancelHandler = () => {
        props.back();
    };

    const handleCancelPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            cancelHandler();
        }        
    };

    return(
        <Fragment >
            <div id='popupContainer' 
                     tabIndex={0} 
                     className={classes.popup_box} 
                     role="dialog" 
                     aria-labelledby="popupTitle" 
                     aria-describedby="popupDesc"
                     onKeyDown={handleEscape}
            >
                <div className={classes.content}>
                    <div>
                        <img alt='' className={classes.top_img}  src={passkeyImg} aria-hidden="true"/> 
                    </div>
                    <div className={classes.popup_title} id='popupTitle' role="heading" aria-level={2}>                       
                        {Translate('N_Login_Pk_Renewal_Time')}
                    </div>
                    <div className={classes.popup_desc} id='popupDesc' >
                        {Translate('N_Login_Pk_Renewal_Desc')}                       
                    </div>
                                  
                    <div className={classes.popup_button_container}>
                        <button 
                            id='btnPkExpired'
                            className={classes.popup_button}
                            onClick={handleContinueClick}
                            onKeyPress={handleContinuePress}
                            tabIndex={0}
                        >
                            {Translate('N_Login_Pk_Renewal')}                            
                            <img alt='' src={(_curLang === 'en' || _curLang === 'ru' ? arrowRightWhite : arrowLeftWhite)} className={classes.pk_btn_arrow} aria-hidden="true"/>
                        </button>                       
                    </div>

                    <div 
                        className={classes.pk_cancel_link} 
                        id="cancelJoin" 
                        role="link" 
                        tabIndex={0} 
                        onClick={cancelHandler}
                        onKeyPress={handleCancelPress}
                    >
                        <span>{Translate('N_Login_Bio_ID_button')}</span>                         
                    </div>                  
                </div>               
            </div>
        </Fragment>      
     );
};

export default PassKeyExpiredPopup